<template>
  <div class="mask-enjoy" v-show="state" :style="{backgroundColor:isWxMini?'transparent':'#000'}" @click.stop="handleClose" @touchmove.prevent>
    <img width="128" height="38" src="https://files.wondercv.com/m/bbs/share.png" alt="" v-if="isWxMini">
    <img width="40" height="40" src="https://files.wondercv.com/groupon_calendar/image/arrow.png" style="margin-right: 10px" alt=""
         v-if="!isWxMini">
    <div class="desc" v-if="!isWxMini">点击右上角【…】<br/>
      {{desc || '私信好友或分享群'}}
    </div>

  </div>
</template>

<script>
  import {envMixin} from "../../assets/js/mixin/global";

  export default {
    name: 'w-share-wx',
    props: {
      state: {
        type: Boolean,
        default: false
      },
      desc: {
        type: String,
        default: ''
      }
    },
    mixins: [envMixin],
    data() {
      return {}
    },
    mounted() {
    },
    computed: {},
    watch: {},
    components: {},
    methods: {
      handleClose() {
        this.$emit('handleClose')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';

  .mask-enjoy {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    opacity: 0.8;
    z-index: 2001;

    img {
      position: absolute;
      top: 9px;
      right: 7px;
    }

    .desc {
      color: #f0fefe;
      opacity: 1;
      font-size: $font-size-large;
      width: 168px;
      position: absolute;
      top: 72px;
      right: 78px;
      font-weight: 500;
      line-height: 26px;
    }
  }
</style>
